import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { Button } from 'src/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'src/components/ui/collapsible'
import { cn } from 'src/lib/utils'

export const NavGroup = ({ group, isCollapsed, children }) => {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  // Check if any child item is active (for visual highlighting only)
  const hasActiveChild = group.items?.some(item => location.pathname === item.to)

  // In collapsed sidebar, groups are handled by parent NavSection popover
  if (isCollapsed) {
    return <>{children}</>
  }

  // Expanded sidebar - nested collapsible group
  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <Button
          variant="ghost"
          className={cn(
            "w-full justify-start gap-2 pl-6 py-2 h-auto text-sm font-medium",
            hasActiveChild
              ? "bg-accent text-accent-foreground hover:bg-accent/80"
              : "hover:bg-accent/50"
          )}
        >
          <span className="flex-1 text-left">{group.name}</span>
          {isOpen ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-1 pt-1">
        {children}
      </CollapsibleContent>
    </Collapsible>
  )
}
